import React, { useState } from 'react'
import PropTypes from 'prop-types';

import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';

import Icon from '../ui/elements/Icon';
import InputAutocomplete from '../ui/form/InputAutocomplete';
import MultipleInputAutocomplete from '../ui/form/MultipleInputAutocomplete';

import { camelize } from '../../library/strings';

import { Cron } from 'react-js-cron'
import 'react-js-cron/dist/styles.css'

class PriceListMailing extends React.Component {
  constructor(props) {
    super(props);

    const defaultMessageText = [
      'Добрый день!\n',
      '\n',
      'Данное письмо содержит действующий прайс-лист (:branch:) ',
      'с актуальным наличием и ценами по состоянию на %d.%m.%Y %H:%M.',
    ].join('');

    this.state = {
      errors: {
        email: !this.props.priceListMailing.email,
      },
      modified: false,
      cron_condition: (this.props.priceListMailing.cron != '0 9 * * *' &&
        this.props.priceListMailing.cron != '0 9 * * 1' && this.props.priceListMailing.cron != '0 13,18 * * *' &&
        this.props.priceListMailing.cron != '0 9 1 * *' && this.props.priceListMailing.cron != '0 9,17 * * *' &&
        this.props.priceListMailing.cron != '0 18 1,15 * *' &&
        this.props.priceListMailing.cron),
      priceListMailing: {
        ...this.props.priceListMailing,
        branchIds: this.props.priceListMailing.branchIds,
        branchesInSeparateFiles: this.props.priceListMailing.branchesInSeparateFiles,
        cron: this.props.priceListMailing.cron || '0 2 * * *',
        email: this.props.priceListMailing.email || '',
        filename: this.props.priceListMailing.filename || 'turbotrucks-%Y-%m-%d',
        messageSubject: this.props.priceListMailing.messageSubject || 'Прайс-лист TURBOTRUCKS :branch: от %d.%m.%Y',
        messageText: this.props.priceListMailing.messageText || defaultMessageText,
        onlyAvailable: this.props.priceListMailing.onlyAvailable,
        onlyDParts: this.props.priceListMailing.onlyDParts,
        addDParts: this.props.priceListMailing.addDParts,
        priceType: this.props.priceListMailing.priceType || '',
        discountGroupId: this.props.priceListMailing.discountGroupId || '',
        allFord: this.props.priceListMailing.allFord,
        forAtbImport: this.props.priceListMailing.forAtbImport,
        showRetail: this.props.priceListMailing.showRetail,
        hidePrices: this.props.priceListMailing.hidePrices,
        showRealQty: this.props.priceListMailing.showRealQty,
        partMaxQty: this.props.priceListMailing.partMaxQty,
        showMoreThenMinQty: this.props.priceListMailing.showMoreThenMinQty
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeMailable = this.handleChangeMailable.bind(this);
    this.handleChangeCron = this.handleChangeCron.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeCronInput = this.changeCronInput.bind(this);

    this.form = React.createRef();
  }

  getCurrentElementValue(element) {
    if (element.name.match(/\[\]$/)) {
      return [
        ...document.querySelectorAll(
          `[name="${element.name}"]:checked, [type="hidden"][name="${element.name
          }"]`
        ),
      ].map((element) => element.value);
    }

    if (element.type === 'checkbox') {
      return element.checked;
    }

    return element.value;
  }

  hasErrors() {
    return Object.values(this.state.errors).filter((value) => value).length > 0;
  }

  handleChange(event) {
    const target = event.target;
    const field = target.name.replace(
      /price_list_mailing\[(.+?)\](\[\])?/,
      '$1'
    );
    const value = this.getCurrentElementValue(target);

    this.setState((state) => ({
      errors: { ...state.errors, [camelize(field)]: !target.validity.valid },
      modified: true,
      priceListMailing: {
        ...state.priceListMailing,
        [camelize(field)]: value,
      },
    }));
  }

  handleChangeMailable(item) {
    this.setState((state) => ({
      modified: true,
      priceListMailing: { ...state.priceListMailing, priceListMailable: item },
    }));
  }

  handleChangeCron(value) {
    this.setState((state) => ({
      modified: true,
      priceListMailing: { ...state.priceListMailing, cron: value },
    }));
  }

  changeCronInput(event) {
    const target = event.target;
    this.setState((state) => ({
      cron_condition: target.checked
    }));
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.state.isSubmiting) {
      return;
    }

    this.setState({ isSubmiting: true }, () => {
      const method = this.state.priceListMailing.id ? 'PATCH' : 'POST';
      fetch(
        this.state.priceListMailing.id
          ? `/office/price_list_mailings/${this.state.priceListMailing.id}.json`
          : '/office/price_list_mailings.json',
        {
          body: new FormData(this.form.current),
          credentials: 'same-origin',
          headers: { 'X-CSRF-Token': Rails.csrfToken() },
          method: method,
        }
      )
        .then(function (response) {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
        })
        .then((data) => {
          this.setState(
            { isSubmiting: false, modified: false, priceListMailing: data },
            () => {
              // if (method === 'POST') {
              //   Turbolinks.visit(`/office/price_list_mailings/${data.id}/edit`);
              // }
              Turbolinks.visit('/office/price_list_mailings');
            }
          );
        })
        .catch((error) => {
          this.setState({ isSubmiting: false });
          alert(
            'Произошла ошибка при попытке сохранения правила отправки прайс-листа.'
          );
        });
    });
  }

  processFormatDirectives(string) {
    const now = new Date();

    return string
      .replace(/%Y/, now.getFullYear())
      .replace(
        /%m/,
        `${now.getMonth() + 1 < 10 ? '0' : ''}${now.getMonth() + 1}`
      )
      .replace(/%d/, `${now.getDate() < 10 ? '0' : ''}${now.getDate()}`)
      .replace(/%H/, `${now.getHours() < 10 ? '0' : ''}${now.getHours()}`)
      .replace(/%M/, `${now.getMinutes() < 10 ? '0' : ''}${now.getMinutes()}`)
      .replace(/:branch:/, this.templateBranchNames);
  }

  get templateBranchNames() {
    if (this.state.priceListMailing.branchesInSeparateFiles) {
      if (this.state.priceListMailing.branchIds.length > 0 && parseInt(this.state.priceListMailing.branchIds[0]) > 0) {
        return this.props.branches.find((el) => el.id === parseInt(this.state.priceListMailing.branchIds[0])).name;
      } else {
        return ':branch:';
      }
    } else {
      if (this.state.priceListMailing.branchIds.length > 0) {
        return this.props.branches
          .filter((el) => {
            return this.state.priceListMailing.branchIds.indexOf(el.id) >= 0 ||
              this.state.priceListMailing.branchIds.indexOf(el.id.toString()) >= 0;
          })
          .map((el) => el.name)
          .join(', ');
      } else {
        return ':branch:';
      }
    }
  }

  render() {
    return (
      <form
        id="price_list_mailing"
        ref={this.form}
        onSubmit={this.handleSubmit}
      >
        <div className="box">
          <p className="is-size-4 has-text-weight-bold" style={{marginBottom: '1rem'}}>Настройки получателя</p>

          <div className="field">
            <label className="label">Получатель</label>
            <div className="control">
              <input
                type="hidden"
                name="price_list_mailing[price_list_mailable_type]"
                defaultValue={
                  this.state.priceListMailing.priceListMailable &&
                  this.state.priceListMailing.priceListMailable.type
                }
              />
              <input
                type="hidden"
                name="price_list_mailing[price_list_mailable_id]"
                defaultValue={
                  this.state.priceListMailing.priceListMailable &&
                  this.state.priceListMailing.priceListMailable.id
                }
              />
              <InputAutocomplete
                item={this.state.priceListMailing.priceListMailable}
                itemDecorator={(item) => {
                  return (
                    <React.Fragment>
                      <Icon icon={item.type === 'User' ? 'user' : 'building'}/>{' '}
                      {item.fullName}
                    </React.Fragment>
                  );
                }}
                onChange={this.handleChangeMailable}
                textDecorator={(item) => item && item.fullName}
                url="/office/search_client.json"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Тип ценообразования у клиента</label>
            <div className="control">
            <span>
              {this.state.priceListMailing.priceListMailable &&
                this.state.priceListMailing.priceListMailable.pricePolicyName}
            </span>
            </div>
          </div>

          <div className="field">
            <label className="label" style={{width: 'max-content', display: 'inline-block'}}>Тип ценобразования</label>

            {this.render_hint()}

            <div className="control">
              <div className="select">
                <select
                  name="price_list_mailing[price_type]"
                  value={this.state.priceListMailing.priceType}
                  onChange={this.handleChange}
                >
                  <option value="">Как у клиента</option>
                  {this.props.priceTypes.map((data, index) => (
                    <option key={index} value={data[0]}>{data[1]}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="field">
            <label className="label">Группа скидок (для розничных цен)</label>
            <div className="control">
              <div className="select">
                <select
                  name="price_list_mailing[discount_group_id]"
                  value={this.state.priceListMailing.discountGroupId}
                  onChange={this.handleChange}
                >
                  <option value="">Без группы скидок</option>
                  {this.props.discountGroups.map((data, index) => (
                    <option key={index} value={data[0]}>{data[1]}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="field">
            <label className="label">Электронная почта</label>
            <div className="control">
              <input
                className={`input ${this.state.errors.email && 'is-danger'}`}
                name="price_list_mailing[email]"
                required
                type="text"
                value={this.state.priceListMailing.email}
                onChange={this.handleChange}
              />
            </div>
            <p className="help">
              Почта, на которую будет отправлен прайс-лист. Можно указать
              несколько адресов через запятую.
            </p>
          </div>
        </div>


        <div className="box">
          <p className="is-size-4 has-text-weight-bold" style={{marginBottom: '1rem'}}>Настройки содержимого прайс-листа</p>

          <div className="field">
            <label className="label">
              Бренды, которые должны быть в прайс-листе
            </label>
            <div className="control">
              <MultipleInputAutocomplete
                items={this.state.priceListMailing.brands.map((brand) => ({
                  ...brand,
                  text: brand.name,
                }))}
                name="price_list_mailing[brand_ids]"
                onChange={this.handleChange}
                itemDecorator={(item) => (
                  <React.Fragment>
                    <Icon icon="circle"/> {item.name}
                  </React.Fragment>
                )}
                textDecorator={(item) => item && item.name}
                valueDecorator={(item) => item && item.id}
                url="/office/brands/search.json"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">
              Бренды, которые должны быть исключены из прайс-листа
            </label>
            <div className="control">
              <MultipleInputAutocomplete
                items={this.state.priceListMailing.excludedBrands.map((brand) => ({
                  ...brand,
                  text: brand.name,
                }))}
                itemDecorator={(item) => (
                  <React.Fragment>
                    <Icon icon="circle"/> {item.name}
                  </React.Fragment>
                )}
                name="price_list_mailing[excluded_brand_ids]"
                onChange={this.handleChange}
                textDecorator={(item) => item && item.name}
                valueDecorator={(item) => item && item.id}
                url="/office/brands/search.json"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">
              Детали, которые должны быть исключены из прайс-листа
            </label>
            <div className="control">
              <MultipleInputAutocomplete
                items={this.state.priceListMailing.excludedParts.map((part) => ({
                  ...part,
                  text: part.name,
                }))}
                itemDecorator={(item) => (
                  <React.Fragment>
                    <Icon icon="box"/> {item.name}
                  </React.Fragment>
                )}
                name="price_list_mailing[excluded_part_ids]"
                onChange={this.handleChange}
                textDecorator={(item) => item && item.shortName}
                valueDecorator={(item) => item && item.id}
                url="/office/parts/search.json"
              />
            </div>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[branches_in_separate_files]"
                  type="hidden"
                  value="0"
                />
                <input
                  name="price_list_mailing[branches_in_separate_files]"
                  type="checkbox"
                  value="1"
                  checked={this.state.priceListMailing.branchesInSeparateFiles}
                  onChange={this.handleChange}
                />{' '}
                Каждый филиал и поставщик отправляется отдельным файлом
              </label>
            </div>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[only_available]"
                  type="hidden"
                  value="0"
                />
                <input
                  name="price_list_mailing[only_available]"
                  type="checkbox"
                  value="1"
                  checked={this.state.priceListMailing.onlyAvailable}
                  onChange={this.handleChange}
                />{' '}
                В прайс включаются только детали, присутствующие в наличии
                <i> (Если галка не установлена - отправится полный прайс-лист в независимости от выбранных филиалов)</i>
              </label>
            </div>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[all_ford]"
                  type="hidden"
                  value="0"
                />
                <input
                  name="price_list_mailing[all_ford]"
                  type="checkbox"
                  value="1"
                  checked={this.state.priceListMailing.allFord}
                  onChange={this.handleChange}
                />{' '}
                Специальный полный прайс-лист Ford
                <div className="dropdown is-right is-hoverable" style={{marginTop: '-0.2rem'}}>
                  <div className="dropdown-trigger is-link">
                    <span className="icon "><i className="far fa-question-circle fa-"></i></span>
                  </div>

                  <div className="dropdown-menu" role="menu" style={{right: 'auto'}}>
                    <div className="dropdown-content">
                      <div className="dropdown-item">
                        <p>
                          При включении этой опции фильтр по бренду автоматически не проставится.
                          Бренды, которые попадут в прайс нужно выбирать отдельно.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[for_atb_import]"
                  type="hidden"
                  value="0"
                />
                <input
                  name="price_list_mailing[for_atb_import]"
                  type="checkbox"
                  value="1"
                  checked={this.state.priceListMailing.forAtbImport}
                  onChange={this.handleChange}
                />{' '}
                Специальный формат АТБ ТРАНС
              </label>
            </div>
          </div>

          <div className="field">
            <label className="label">Наличие в филиалах</label>
            <div className="columns is-gapless is-multiline">
              {this.props.branches.map((branch) => (
                <div key={branch.id} className="column is-2">
                  <div className="field">
                    <div className="control">
                      <label className="checkbox">
                        <input
                          name="price_list_mailing[branch_ids][]"
                          type="hidden"
                          value="0"
                        />
                        <input
                          name="price_list_mailing[branch_ids][]"
                          type="checkbox"
                          value={branch.id}
                          checked={
                            this.state.priceListMailing.branchIds.indexOf(
                              branch.id
                            ) >= 0 ||
                            this.state.priceListMailing.branchIds.indexOf(
                              branch.id.toString()
                            ) >= 0
                          }
                          onChange={this.handleChange}
                        />
                        {` ${branch.name}`}
                      </label>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="field">
            <label className="label">
              Прайс-листы поставщиков, которые должны быть в прайс-листе
            </label>
            <div className="control">
              <MultipleInputAutocomplete
                items={this.state.priceListMailing.priceRules.map((priceRule) => ({
                  ...priceRule,
                  text: priceRule.fullName,
                }))}
                name="price_list_mailing[price_rule_ids]"
                onChange={this.handleChange}
                itemDecorator={(item) => (
                  <React.Fragment>
                    <Icon icon="circle"/> {item.fullName}
                  </React.Fragment>
                )}
                textDecorator={(item) => item && item.fullName}
                valueDecorator={(item) => item && item.id}
                url="/office/price_rules/search.json"
              />
            </div>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[hide_prices]"
                  type="hidden"
                  value="0"
                />
                <input
                  checked={this.state.priceListMailing.hidePrices}
                  name="price_list_mailing[hide_prices]"
                  onChange={this.handleChange}
                  type="checkbox"
                  value="1"
                />{' '}
                Скрыть цены?
              </label>
            </div>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[show_real_qty]"
                  type="hidden"
                  value="0"
                />
                <input
                  checked={this.state.priceListMailing.showRealQty}
                  name="price_list_mailing[show_real_qty]"
                  onChange={this.handleChange}
                  type="checkbox"
                  value="1"
                />{' '}
                Отображать точное количество деталей на наших складах
              </label>
            </div>
          </div>

          <div className="field"
               style={this.state.priceListMailing.showRealQty ? {display: 'none'} : {display: 'block'}}>
            <label className="label">Максимальное отображаемое количество</label>
            <div className="control">
              <input
                className="input"
                name="price_list_mailing[part_max_qty]"
                type="text"
                value={this.state.priceListMailing.partMaxQty}
                onChange={this.handleChange}
              />
            </div>
            <p className="help">
              Какое количество отображается в прайс-листе, если клиент не видит точное количество на наших складах.
            </p>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[show_retail]"
                  type="hidden"
                  value="0"
                />
                <input
                  checked={this.state.priceListMailing.showRetail}
                  name="price_list_mailing[show_retail]"
                  onChange={this.handleChange}
                  type="checkbox"
                  value="1"
                />{' '}
                Колонка с розничной ценой
              </label>
            </div>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[show_more_then_min_qty]"
                  type="hidden"
                  value="0"
                />
                <input
                  checked={this.state.priceListMailing.showMoreThenMinQty}
                  name="price_list_mailing[show_more_then_min_qty]"
                  onChange={this.handleChange}
                  type="checkbox"
                  value="1"
                />{' '}
                Только детали, минимальный остаток товара которых (с учетом резерва) больше среднемесячного запаса
                <div className="dropdown is-right is-hoverable" style={{marginTop: '-0.2rem'}}>
                  <div className="dropdown-trigger is-link">
                    <span className="icon "><i className="far fa-question-circle fa-"></i></span>
                  </div>

                  <div className="dropdown-menu" role="menu" style={{right: 'auto'}}>
                    <div className="dropdown-content">
                      <div className="dropdown-item">
                        <p>Если эта настройка включена, в прайс-лист попадут только те детали, минимальный остаток
                          которых, с учетом резерва на складе, больше среднемесячного запаса.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[only_d_parts]"
                  type="hidden"
                  value="0"
                />
                <input
                  checked={this.state.priceListMailing.onlyDParts}
                  name="price_list_mailing[only_d_parts]"
                  onChange={this.handleChange}
                  type="checkbox"
                  value="1"
                />{' '}
                Только детали категории D
                <div className="dropdown is-right is-hoverable" style={{marginTop: '-0.2rem'}}>
                  <div className="dropdown-trigger is-link">
                    <span className="icon "><i className="far fa-question-circle fa-"></i></span>
                  </div>

                  <div className="dropdown-menu" role="menu" style={{right: 'auto'}}>
                    <div className="dropdown-content">
                      <div className="dropdown-item">
                        <p>Если эта настройка включена, в прайс-лист попадают детали ТОЛЬКО категории D, указанных
                          брендов, которые есть в наличии в указанных филиалах и т. д. в зависимости от настроек.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>

          <div className="field">
            <div className="control">
              <label className="checkbox label">
                <input
                  name="price_list_mailing[add_d_parts]"
                  type="hidden"
                  value="0"
                />
                <input
                  checked={this.state.priceListMailing.addDParts}
                  name="price_list_mailing[add_d_parts]"
                  onChange={this.handleChange}
                  type="checkbox"
                  value="1"
                />{' '}
                Добавить все детали категории D всех брендов
                <div className="dropdown is-right is-hoverable" style={{marginTop: '-0.2rem'}}>
                  <div className="dropdown-trigger is-link">
                    <span className="icon "><i className="far fa-question-circle fa-"></i></span>
                  </div>

                  <div className="dropdown-menu" role="menu" style={{right: 'auto'}}>
                    <div className="dropdown-content">
                      <div className="dropdown-item">
                        <p>Если эта настройка включена, в прайс-лист попадают детали указанных брендов, которые есть в
                          наличии в указанных филиалах и т. д. в зависимости от настроек + детали категории D всех
                          брендов.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>


        <div className="box">
          <p className="is-size-4 has-text-weight-bold" style={{marginBottom: '1rem'}}>Настройки формата прайс-листа</p>

          <div className="field">
            <label className="label">Расписание (в формате cron)</label>
            <div className="control">
              <label className="checkbox">
                <input
                  name="know_cron"
                  type="checkbox"
                  value="1"
                  checked={this.state.cron_condition}
                  onChange={this.changeCronInput}
                />{' '}
                Я хочу самостоятельно настроить периодичность рассылки
              </label>
            </div>
            <div className="control cron_select"
                 style={this.state.cron_condition ? {display: 'none'} : {display: 'block'}}>
              <div className="select">
                <select
                  name="price_list_mailing[cron]"
                  value={this.state.priceListMailing.cron}
                  onChange={this.handleChange}
                  style={this.state.cron_condition ? {display: 'none'} : {display: 'block'}}
                >
                  <option value="">Выберите периодичность рассылки</option>
                  <option value='0 9 * * *'>Каждый день в 09:00</option>
                  <option value='0 9,17 * * *'>Каждый день в 09:00 и 17:00</option>
                  <option value='0 13,18 * * *'>Каждый день в 13:00 и 18:00</option>
                  <option value='0 9 * * 1'>Каждый понедельник в 09:00</option>
                  <option value='0 9 1 * *'>Каждое первое число месяца в 09:00</option>
                  <option value='0 18 1,15 * *'>Каждое 1 и 15 число месяца в 18:00</option>
                </select>
              </div>
            </div>

            <div className="control cron_input"
                 style={this.state.cron_condition ? {display: 'block'} : {display: 'none'}}>
              <Cron
                value={this.state.priceListMailing.cron}
                setValue={this.handleChangeCron}
                leadingZero={true}
                clearButton={false}
                allowedPeriods={['month', 'week', 'day']}
                locale={{
                  everyText: 'каждый',
                  emptyMonths: 'каждый месяц',
                  emptyMonthDays: 'каждый день месяца',
                  emptyMonthDaysShort: 'день месяца',
                  emptyWeekDays: 'каждый день недели',
                  emptyWeekDaysShort: 'день недели',
                  emptyHours: 'каждый час',
                  emptyMinutes: 'каждую минуту',
                  emptyMinutesForHourPeriod: 'каждый',
                  yearOption: 'год',
                  monthOption: 'месяц',
                  weekOption: 'неделя',
                  dayOption: 'день',
                  hourOption: 'час',
                  minuteOption: 'минута',
                  rebootOption: 'перезагрузка',
                  prefixPeriod: 'Каждый(-ая)',
                  prefixMonths: '',
                  prefixMonthDays: '',
                  prefixWeekDays: 'в',
                  prefixWeekDaysForMonthAndYearPeriod: 'или в',
                  prefixHours: 'в',
                  prefixMinutes: ':',
                  prefixMinutesForHourPeriod: 'в',
                  suffixMinutesForHourPeriod: 'мин',
                  errorInvalidCron: 'Неверное выражение',
                  weekDays: [
                    'Воскресенье',
                    'Понедельник',
                    'Вторник',
                    'Среда',
                    'Четверг',
                    'Пятница',
                    'Суббота'
                  ],
                  months: [
                    'Январь',
                    'Февраль',
                    'Март',
                    'Апрель',
                    'Май',
                    'Июнь',
                    'Июль',
                    'Август',
                    'Сентябрь',
                    'Октябрь',
                    'Ноябрь',
                    'Декабрь'
                  ],
                  altWeekDays: [
                    'Воскресенье',
                    'Понедельник',
                    'Вторник',
                    'Среда',
                    'Четверг',
                    'Пятница',
                    'Суббота'
                  ],
                  altMonths: [
                    'Январь',
                    'Февраль',
                    'Март',
                    'Апрель',
                    'Май',
                    'Июнь',
                    'Июль',
                    'Август',
                    'Сентябрь',
                    'Октябрь',
                    'Ноябрь',
                    'Декабрь'
                  ]
                }}
              />

              <input
                className={`input ${this.state.errors.cron && 'is-danger'}`}
                name="price_list_mailing[cron]"
                required
                type="text"
                style={this.state.cron_condition ? {display: 'block'} : {display: 'none'}}
                value={this.state.priceListMailing.cron || ''}
                readOnly={true}
                onChange={this.handleChange}
              />

            </div>
          </div>

          <div className="field">
            <label className="label">Формат файла</label>
            <div className="control">
              <div className="select">
                <select
                  name="price_list_mailing[format]"
                  value={this.state.priceListMailing.format}
                  onChange={this.handleChange}
                >
                  <option value="xlsx">Excel</option>
                  <option value="csv">CSV</option>
                </select>
              </div>
            </div>
          </div>

          <div className="field">
            <label className="label">Название файла</label>
            <div className="control">
              <input
                className={`input ${this.state.errors.filename && 'is-danger'}`}
                name="price_list_mailing[filename]"
                required
                type="text"
                value={this.state.priceListMailing.filename}
                onChange={this.handleChange}
              />
            </div>
            <p className="help">
              {this.processFormatDirectives(this.state.priceListMailing.filename)}.
              {this.state.priceListMailing.format}
            </p>
          </div>

          <div className="field">
            <label className="label">Тема письма с прайсом</label>
            <div className="control">
              <input
                className="input"
                name="price_list_mailing[message_subject]"
                type="text"
                value={this.state.priceListMailing.messageSubject}
                onChange={this.handleChange}
              />
            </div>
            <p className="help">
              {this.processFormatDirectives(
                this.state.priceListMailing.messageSubject
              )}
            </p>
          </div>

          <div className="field">
            <label className="label">Текст письма с прайсом</label>
            <div className="control">
            <textarea
              className="textarea"
              name="price_list_mailing[message_text]"
              value={this.state.priceListMailing.messageText}
              onChange={this.handleChange}
            />
            </div>
            <pre className="help">
            {this.processFormatDirectives(
              this.state.priceListMailing.messageText
            )}
          </pre>
          </div>

        </div>

        <div className="field is-grouped">
          <div className="control">
            <button
              className={`button is-primary ${this.state.isSubmiting &&
              'is-loading'}`}
              disabled={
                !this.state.modified ||
                this.hasErrors() ||
                this.state.isSubmiting
              }
              type="submit"
            >
              {this.state.modified &&
                (this.state.priceListMailing.id
                  ? 'Сохранить изменения'
                  : 'Добавить настройку прайс-листа')}
              {!this.state.modified && 'Изменения сохранены'}
            </button>
          </div>
          <div className="control">
            <a className="button is-text" href="/office/price_list_mailings">
              вернуться ко всем настройкам прайс-листов
            </a>
          </div>
        </div>
      </form>
  );
  }

  render_hint() {
    return (
      <div className="dropdown is-right is-hoverable">
        <div className="dropdown-trigger is-link">
          <span className="icon "><i className="far fa-question-circle fa-"></i></span>
        </div>

        <div className="dropdown-menu" role="menu" style={{right: 'auto'}}>
          <div className="dropdown-content">
            <div className="dropdown-item">
              <p>При указании не как у клиента, цены в прайс-листе будут без учета специальных цен клиента и без учета
                специального ценообразования.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PriceListMailing.propTypes = {
  branches: PropTypes.arrayOf(PropTypes.object),
  priceListMailing: PropTypes.object,
  priceTypes: PropTypes.arrayOf(PropTypes.array),
  discountGroups: PropTypes.arrayOf(PropTypes.array)
};

export default PriceListMailing;
